import React, { Fragment, useState, useEffect, useCallback } from "react";
import { print } from "graphql";
import { Mutation } from "@apollo/client/react/components";
import { Redirect, withRouter } from "react-router-dom";
import SimpleModal from "../../SimpleModal";
import SimpleForm from "../../SimpleForm";
import inputResolver from "../../SimpleForm/FieldResolver";
import UISchemaResolver from "../../../data/schema/form_ui/_resolver";
import PrefillUtil from "../../../global/utils/prefillHelper";
import util from "../../Utils/mappers";
import GQLUtil from "../../../global/utils/gqlHelper";
import { connect, useDispatch, useSelector } from "react-redux";
import FormExit from "../../SimpleForm/UI/FormExit";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import {
  GET_9141C_FORM_DATA,
  UPDATE_9141C_FORM,
  SUBMIT_9141C_FORM,
  GET_9141C_PROFILES,
} from "./queries";
import { cleanData, pageLockData } from "./helpers.js";
import renderFormActions from "../renderFormActions";
import renderDeleteButton from "../renderDeleteButton";
import renderSaveButton from "../renderSaveButton";
import isTester from "../../SimpleForm/SubmissionUtilities/isTester";
import FullScreenSpinner from "../../../global/components/FullScreenSpinner";
import { usePageLock } from "../../Hooks/usePageLock";
import { fetchAllReferenceData } from "../../../global/app/actions/actions_reference";

function Form9141C(props) {
  const [profiles, setProfiles] = useState(null);
  const [counties, setCounties] = useState([]);
  const [formData, setFormData] = useState(undefined);
  const [form_ui, setForm_ui] = useState(undefined);
  const user = useSelector((props) => props.appReducer.userDataReducer.data);
  const useRecaptcha = user.Recaptcha !== false;
  const { executeRecaptcha } = useGoogleReCaptcha();
  const dispatch = useDispatch();

  const pageLock = usePageLock(pageLockData);

  useEffect(() => {
    const application_type = "9141C";
    const application_id = props.match.params.id;
    let profiles, form;

    // if user is currently in app and reference data updates we want to fetch latest data when they open up the form
    // before we were checking if data existed in redux and if so skipping the fetch and not getting the latest data
    dispatch(fetchAllReferenceData());

    const fetchProfiles = async () => {
      profiles = await GQLUtil.genericGQLQuery(print(GET_9141C_PROFILES));
      const profiles_parsed = PrefillUtil.getPrefillProfileOptions(
        profiles.data.getUserProfileInfo,
        application_type,
        "all"
      );
      setProfiles(profiles_parsed);
    };
    fetchProfiles().catch(console.error);

    const fetchFormData = async () => {
      form = await GQLUtil.genericGQLQuery(print(GET_9141C_FORM_DATA), {
        id: application_id,
      });
      if (form.data !== null) {
        let _formData = form.data.getForm9141CById.payload;
        let _form_ui = form.data.getForm9141CById.form_ui;
        setFormData({
          ..._formData,
          formVersionId: form?.data?.getForm9141CById?.formVersionId,
        });
        setForm_ui(_form_ui);
      } else {
        props.history.push("/dashboard/application");
      }
    };
    fetchFormData().catch(console.error);

    util
      .getCounties()
      .then((data) => setCounties(data))
      .catch((e) => console.log(`Unable to fetch counties. ${e}`));
  }, []);

  const Render9141C = () => {
    const [formSubmitting, setFormSubmitting] = useState(false);
    const [closeModal, setcloseModal] = useState(false);
    const [modalOpen, setModalOpen] = useState(true);
    const application_type = "9141C";
    const resolverName = "SubmitForm9141C";
    const application_id = props.match.params.id;

    const handleToggle = () => {
      setcloseModal(!closeModal);
    };

    const renderFormExit = (values, form_ui, form_ui_name) => {
      return (
        <FormExit
          renderDeleteButton={() =>
            renderDeleteButton(
              application_id,
              application_type,
              props.history,
              values,
              user.GroupRole
            )
          }
          renderSaveButton={() =>
            renderSaveButton(
              UPDATE_9141C_FORM,
              values,
              "Form9141CFormData",
              application_id,
              cleanData,
              props.history,
              "Save as Initiated",
              undefined,
              undefined,
              form_ui,
              form_ui_name
            )
          }
          closeModal={closeModal}
          toggleModal={handleToggle}
          values={values}
        />
      );
    };

    const formSubmissionError = (e, application_id) => {
      setFormSubmitting(false);
      if (e) {
        let type;
        let error = JSON.stringify(e);

        if (
          e &&
          e.graphQLErrors &&
          e.graphQLErrors[0] &&
          e.graphQLErrors[0].extensions
        ) {
          error = e.graphQLErrors[0].extensions;
        }
        if (
          e &&
          e.graphQLErrors &&
          e.graphQLErrors[0] &&
          e.graphQLErrors[0].message
        ) {
          type = e.graphQLErrors[0].message;
        }
        props.history.push({
          pathname: "/dashboard/error",
          state: {
            formType: application_type,
            error: error,
            application_id,
            type,
          },
        });
      }
    };

    const formSubmissionSuccess = (res) => {
      const queueError = res?.[`${resolverName}`] === "queue_error";
      setFormSubmitting(false);
      props.history.push({
        pathname: "/dashboard/success",
        state: { formType: application_type, queueError },
      });
    };

    return profiles ? (
      <Fragment>
        {!modalOpen ? (
          <Redirect to="/dashboard/application" />
        ) : (
          <SimpleModal
            fullscreen={true}
            toggleModal={handleToggle}
            modalStatus={modalOpen}
          >
            <Mutation
              onError={(e) => formSubmissionError(e, application_id)}
              onCompleted={(e) => formSubmissionSuccess(e)}
              mutation={SUBMIT_9141C_FORM}
            >
              {(SubmitForm9141C) => (
                <SimpleForm
                  handleSubmit={
                    useRecaptcha
                      ? async (values) => {
                          if (!executeRecaptcha) {
                            return;
                          }
                          const token = await executeRecaptcha(resolverName);
                          SubmitForm9141C({
                            variables: {
                              Form9141CFormData: cleanData(values),
                              id: application_id,
                              token,
                            },
                          });
                        }
                      : (values) => {
                          SubmitForm9141C({
                            variables: {
                              Form9141CFormData: cleanData(values),
                              id: application_id,
                            },
                          });
                        }
                  }
                  toggleClose={handleToggle}
                  toggleModal={handleToggle}
                  formExit={closeModal}
                  renderFormExit={renderFormExit}
                  renderFormActions={renderFormActions(
                    UPDATE_9141C_FORM,
                    "Form9141CFormData",
                    application_id,
                    cleanData,
                    props.history,
                    formSubmitting
                  )}
                  formSaveMutation={UPDATE_9141C_FORM}
                  formSaveMutationCallback={({
                    formValues,
                    formUIData,
                    saveForm,
                    profilePrefillMetadata,
                  }) => {
                    saveForm({
                      variables: {
                        formUI9141C: formUIData,
                        Form9141CFormData: cleanData(formValues),
                        id: application_id,
                        profilePrefillMetadata: profilePrefillMetadata.profiles,
                      },
                    });
                  }}
                  multiPage={true}
                  uiSchema={UISchemaResolver(application_type)}
                  uiSchema_meta={UISchemaResolver(`${application_type}-meta`)}
                  uiSchema_nav={UISchemaResolver(`${application_type}-nav`)}
                  uiSchema_lookup={UISchemaResolver(
                    `${application_type}-lookup`
                  )}
                  inputResolver={inputResolver}
                  initialValues={formData || {}}
                  profiles={profiles}
                  counties={counties}
                  form_ui={form_ui}
                  form_ui_name={"formUI9141C"}
                  formSubmitting={formSubmitting}
                  pageLock={pageLock}
                  disableValidation={
                    (user &&
                      user.Roles &&
                      isTester(user && user.Roles)) ||
                    false
                  }
                />
              )}
            </Mutation>
          </SimpleModal>
        )}
      </Fragment>
    ) : null;
  };
  // form_ui is undefined but is null on 9142A
  if (
    formData !== undefined &&
    form_ui !== null &&
    profiles !== null &&
    counties?.length !== 0
  ) {
    return (
      <div>
        <Render9141C />
      </div>
    );
  }

  return <FullScreenSpinner />;
}

export default Form9141C;
